<template>
    <div class="nodata">
        <div class="nodata-box">
            <p>
                <i class="iconfont icon-zanwushuju"></i>
            </p>
            <p>暂无数据</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NoData"
    }
</script>

<style scoped lang="scss">
        .nodata{
            width: 100%;
            height: 100%;
            position: relative;

            .nodata-box{
                position:absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: #f0f0f0;
                p{
                    width: 100%;
                    text-align: center;
                }
                p:nth-child(2){
                    /*color: ;*/
                    margin-bottom: 10px;
                    font-size: 24px;
                }
                p:nth-child(1){
                    i{
                        font-size: 100px;
                    }

                }
            }
        }
</style>